import {Pipe, PipeTransform} from '@angular/core';
import {FileInfo} from '../../types/file/file-info';

@Pipe({name: 'fileInfoName'})
export class FileInfoNamePipe implements PipeTransform {
  transform(file: FileInfo, name: string): string {
    if (file.type === 'SAFE_FROM_HARM_POLICY' || file.type === 'SAFE_FROM_HARM_REPORTING') {
      return `${name}`;
    } else {
      return file.year ?
        `${file.year.toString()} ${name}` : file.fileName;
    }
  }
}
